<template>
  <v-layout row
            wrap>
    <v-flex xs12>
      <crud resource="clients"
            v-on:client-created="clientCreated"
            :manager="manager"/>
    </v-flex>
  </v-layout>
</template>

<script>
  import Crud from './Crud'
  import CrudBase from './CrudBase.vue'

  export default {
    name: 'Clients',
    extends: CrudBase,
    components: {Crud},
    methods: {
      clientCreated () {

      },
      initialize () {
        let that = this
        this.manager.deletable = (item) => {
          return item.email !== 'testclient@cube-messenger.com'
        }
        this.manager.toValue = (header, item) => {
          if (header.value === 'balance') {
            return item.balance ? that.$app.formatMoney(item.balance) : that.defaultValue
          } else if (header.value === 'limit') {
            return item.limit ? that.$app.formatMoney(item.limit) : that.defaultValue
          } else {
            return item[header.value] ? item[header.value] : that.defaultValue
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Clients.vue